import { isPlatformBrowser } from '@angular/common';
import { InjectionToken, PLATFORM_ID, Service, inject } from '@angular/core';

import type { ErrorReport } from '@app/core/errors/error-report.types';
import { environment } from '@env/environment';

export const ERROR_REPORT_DESTINATION = new InjectionToken<string | null>('ERROR_REPORT_DESTINATION', {
  providedIn: 'root',
  factory: () => environment.errorReportEndpoint,
});

@Service()
export class ErrorReporter {
  private readonly destination = inject(ERROR_REPORT_DESTINATION);
  private readonly platformId = inject(PLATFORM_ID);

  public report(report: ErrorReport): void {
    this.echoWhileNotInProduction(report);

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.sendToDeclaredDestination(report);
  }

  private echoWhileNotInProduction(report: ErrorReport): void {
    if (environment.name === 'production') {
      return;
    }

    // eslint-disable-next-line no-console
    console.error('[erro]', report);
  }

  private sendToDeclaredDestination(report: ErrorReport): void {
    const destination = this.destination;

    if (destination === null || typeof navigator.sendBeacon !== 'function') {
      return;
    }

    navigator.sendBeacon(destination, JSON.stringify(report));
  }
}
